import { IStatusProp } from "./module/costants";
import classes from "./Status.module.scss";
import messages from "./module/messages";
import { FormattedMessage } from "react-intl";

const Status = (props: IStatusProp): JSX.Element => {
  const { status } = props;
  const statusLabel = status.toUpperCase();
  return (
    <div className={`${classes.badge} ${classes[`${status}`]}`}>
      <strong>
        {
          <FormattedMessage
            {...messages[statusLabel as keyof typeof messages]}
          />
        }
      </strong>
    </div>
  );
};

export default Status;
